module.exports = __webpack_public_path__ + "static/media/conference_27.d60af276.jpg";